import { ReactNode } from 'react';
import { RuleSet } from 'styled-components';
import {
  ChildrenContainer,
  FilterSectionContainer,
  SectionTitle
} from './styled';

interface FiltersSectionProps {
  title?: string | ReactNode;
  children: ReactNode;
  styles?: RuleSet;
  stat?: string;
}

export const FiltersSection = ({
  title,
  children,
  styles,
  stat
}: FiltersSectionProps) => {
  return (
    <FilterSectionContainer styles={styles} data-stat={stat}>
      {title && <SectionTitle tag="body_1">{title}</SectionTitle>}
      <ChildrenContainer>{children}</ChildrenContainer>
    </FilterSectionContainer>
  );
};
